import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import BrandsSection from '../Section/BrandsSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import BlogSection from '../Section/BlogSection';
import AppointmentSection from '../Section/AppointmentSection';
import FaqSection from '../Section/FaqSection';
import AwardSection from '../Section/AwardSection';
import DepartmentSection from '../Section/DepartmentSection';
import { pageTitle } from '../../helpers/PageTitle';
const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Compassion',
    subTitle:
      'We treat our patients with understanding and empathy, providing supportive care and a welcoming atmosphere for everyone who visits.',
  },
  {
    iconSrc: '/images/home_1/excellence.svg',
    title: 'Excellence',
    subTitle:
      'We are dedicated to delivering accurate,precise and timely results by using top technology and continuously improving skills.',
  },
  {
    iconSrc: '/images/home_1/integrity.svg',
    title: 'Integrity',
    subTitle:
      'We maintain the highest standards of ethics and honesty, ensuring transparent and trustworthy service in all we do.',
  },

  {
    iconSrc: '/images/home_1/teamwork.svg',
    title: 'Teamwork',
    subTitle:
      'We work together as a team, valuing the contributions of each member to provide the best possible care for our patients,',
  },
];
const brandData = [
  { imgUrl: 'images/brand_1.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_2.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_3.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_4.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_5.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_6.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_7.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_8.png', imgAlt: 'Brand' },
];
const faqData = [
  {
    title: "1. Do I need a doctor’s prescription for tests?",
    content:
      "Yes, a doctor’s prescription is recommended for most tests to ensure correct testing and accurate reports.",
  },
  {
    title: '2. Is fasting required before blood tests?',
    content:
      'Some tests require fasting for 8–12 hours. Our staff will inform you clearly at the time of booking.',
  },
  {
    title: '3. How long will it take to get my reports?',
    content:
      'Most reports are available on the same day or within 24 hours, depending on the test.',
  },
  {
    title: '4. Are ultrasound and X-ray scans safe?',
    content:
      'Yes. Ultrasound scans are completely safe and painless. Digital X-rays use minimal radiation and follow safety standards.',
  },
  {
    title: '5. Do you provide home sample collection?',
    content:
      'Yes, free home sample collection is available within selected areas.',
  },
  {
    title: '6. Are your test results accurate and reliable?',
    content:
      'Absolutely. We use modern equipment, strict quality control, and experienced professionals to ensure accuracy.',
  },
  {
    title: '7. How can I book an appointment?',
    content:
      'You can book an appointment by calling us, sending a WhatsApp message, or visiting our center directly.',
  },
  {
    title: '8. Is patient information kept confidential?',
    content:
      'Yes. All patient details and test results are handled with complete privacy and confidentiality.',
  },
  {
    title: '9. What payment methods are accepted?',
    content:
      'We accept cash, UPI, and other digital payment options.',
  },
  {
    title: '10. Where is BRR Diagnostics located?',
    content:
      'We are located in Proddatur. You can find us easily on Google Maps by searching “BRR Diagnostics.”',
  },
];
const blogData = [
  {
    title: 'Why Regular Health Checkups Are Important for Every Family',
    thumbUrl: 'images/real/blog_1.png',
    date: 'January 15, 2024',
    btnText: 'Learn More',
    href: '/blog/health-checkups-importance',
    socialShare: true,
  },
  {
    title: 'Understanding Blood Tests and What They Reveal About Your Health',
    thumbUrl: 'images/real/blog_2.png',
    date: 'January 22, 2024',
    btnText: 'Learn More',
    href: '/blog/understanding-blood-tests',
    socialShare: true,
  },
  {
    title: 'How Ultrasound and Digital X-Ray Help in Early Diagnosis',
    thumbUrl: 'images/real/blog_3.png',
    date: 'February 1, 2024',
    btnText: 'Learn More',
    href: '/blog/ultrasound-xray-diagnosis',
    socialShare: true,
  },
];
const awardData = [
  {
    title: 'Clinical Laboratory',
    subTitle:
      'Accurate blood and sample testing that forms the foundation of correct diagnosis and treatment.',
    iconUrl: '/images/real/dpet- laboratory.png',
  },
  {
    title: 'Digital X-Ray',
    subTitle:
      'Fast, clear, and low-radiation imaging for precise bone and chest evaluation.',
    iconUrl: '/images/real/dept - x ray.png',
  },
  {
    title: 'Ultrasound Scan',
    subTitle:
      'Safe and non-invasive imaging to visualize internal organs and monitor pregnancy with care.',
    iconUrl: '/images/real/dept - ultrasound.png',
  },
  {
    title: 'Blood & Hormone Testing',
    subTitle:
      'Detailed tests to understand body balance, energy levels, fertility, and overall health.',
    iconUrl: '/images/real/dept - hormone .png',
  },
];
const departmentData = [
  {
    title: 'Ultrasound',
    iconUrl: '/images/real/dept_ultrasound.png',
    href: '/tests/ultrasound',
  },
  {
    title: 'Digital X-Ray',
    iconUrl: '/images/real/dept_xray.png',
    href: '/tests/digital-x-ray',
  },
  {
    title: 'Hemotology',
    iconUrl: '/images/real/dept_hematology.png',
    href: '/tests/hemotology',
  },
  {
    title: 'Blood Profiles',
    iconUrl: '/images/real/dept_blood_profiles.png',
    href: '/tests/blood-profiles',
  },
  {
    title: 'Clinical Pathology',
    iconUrl: '/images/real/dept_clinical_pathology.png',
    href: '/tests/clinical-pathology',
  },
  {
    title: 'Serology',
    iconUrl: '/images/real/dept_serology.png',
    href: '/tests/serology',
  },
  {
    title: 'Surgical Profiles',
    iconUrl: '/images/real/dept_surgical_profiles.png',
    href: '/tests/surgical-profiles',
  },
  {
    title: 'Antenatal Profiles',
    iconUrl: '/images/real/dept_antenatal_profiles.png',
    href: '/tests/antenatal-profiles',
  },
  {
    title: 'Hormones',
    iconUrl: '/images/real/dept_hormones.png',
    href: '/tests/hormones',
  },
];

export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        title="<span style='color:#752d45'>Proddatur's Reliable<br/>Diagnostic Center</span>"
        subTitle="Every test. Every time. Accurate.<br/><br/>Modern diagnostic care in Proddatur, offering accurate. timely. and reliable test results to help you and your family stay healthy,"
        bgUrl="/images/home_1/hero_bg.png"
        imgUrl="/images/real/hero_img.png"
        btnText="Book Appointment"
        btnUrl="/contact"
        belowBtnText="Clinical Laboratory&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;Digital X-Ray&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;Ultrasound Scan"
        infoList={[
          {
            title: 'Mobile',
            subTitle: '8790590588',
            iconUrl: '/images/contact/icon_1.svg',
          },

          {
            title: 'Location',
            subTitle: 'Sundaryacharyula Street, Proddatur – 516360',
            iconUrl: '/images/icons/pin.svg',
          },
          {
            title: 'Timings',
            subTitle: '24 Hours',
            iconUrl: '/images/icons/ambulance.svg',
          },
        ]}
      />
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Our Values" data={featureListData} />
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/real/about_us.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About Us"
          subTitle="BRR DIAGNOSTICS"
          featureList={[
            {
              featureListTitle:
                'BRR Diagnostics is a team of experienced medical professionals',
              featureListSubTitle:
                'Committed to delivering accurate and ethical diagnostic care, we use advanced technology and compassionate service to help keep Proddatur healthy.',
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Tests we offer"
          bgUrl="images/home_1/department_bg.svg"
          data={departmentData}
        />
      </Section>

      {/* End Departments Section */}
      {/* Start Award Section */}
      <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle="Departments" data={awardData} />
      </Section>
      {/* End Award Section */}
      
      {/* Start Testimonial */}

      {/* <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle="Some Reviews"
          sectionTitleDown="Of our clients"
        />
      </Section>  */}
      
      {/* End Testimonial */}

      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/real/cta_banner.png"
          title="Don’t Let Your Health Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced medical professionals today!"
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          data={blogData}
        />
      </Section>
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      {/* <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section> */}
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSection data={brandData} />
      </Section>
      {/* End Brand Section */}
    </>
  );
}
